import { Spacer } from "native-base";

export default Spacer;